
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate, NavLink, useParams } from "react-router-dom";
import { alert_error, alert_success } from './../../AppContext';
import Option from './option';
import { Cookies } from './../../index.js';
import Statistic from './../content/statistic';
const Admin_home = () => {
    const [pass, setPass] = useState(Array(6).fill(''));
    const inputsRef = useRef([]);
    const cookie_memory_show_media = Cookies.get('memory_show_media');
    const [memory_show_media, set_memory_show_media] = useState(cookie_memory_show_media);

    const handleChange = (e, index) => {
        const value = e.target.value;
        // Chỉ cho phép nhập 1 ký tự số
        if (!/^\d?$/.test(value)) return;

        const newPass = [...pass];
        newPass[index] = value;
        setPass(newPass);

        // Tự động chuyển focus sang ô tiếp theo nếu chưa đến ô cuối và đã nhập giá trị
        if (value && index < 5) {
            inputsRef.current[index + 1].focus();
        }

        // Nếu đã nhập đủ 6 số, kiểm tra mật khẩu
        if (newPass.every((digit) => digit !== '')) {
            const enteredPass = newPass.join('');
            if (enteredPass === '180105') {
                set_memory_show_media(true);
                alert_success('pass ok mở phương tiện');
                var date = new Date();
                // Thêm 5 ngày vào thời gian hiện tại
                date.setTime(date.getTime() + (5 * 24 * 60 * 60 * 1000)); // 5 ngày * 24 giờ * 60 phút * 60 giây * 1000 miligiây
                // Đặt cookie với thời gian sống là 5 ngày
                Cookies.set('memory_show_media', true, { expires: date });
            } else {
                set_memory_show_media(false);
                alert_error('pass sai thử lại');
            }
        }
    };

    const handleKeyDown = (e, index) => {
        // Nếu bấm Backspace ở ô trống, chuyển focus về ô trước đó
        if (e.key === 'Backspace' && !pass[index] && index > 0) {
            inputsRef.current[index - 1].focus();
        }
    };

    const [json_data, set_json_data] = useState('');
    function laydulieu() {
        axios
            .get('https://hust.media/api/profile/statistic.php')
            .then(response => set_json_data(response.data))
            .catch(error => console.log(error))
    };
    useEffect(() => {
        laydulieu();
    }, []);

    return (
        <>
            {(!memory_show_media && window.location.href.includes('memory')) ? <>
                <div className="mt-3 text-lg text-center">
                    Nhập mật khẩu 6 số
                </div>
                <div className="max-w-2xl mx-auto rounded-xl overflow-hidden">
                    <div className="mt-2 mx-2 grid grid-cols-1">
                        <div className="bg-green-200 bg-opacity-70 p-2 rounded-xl shadow-md md:col-span-2">
                            <div className="flex justify-center space-x-3 md:space-x-5">
                                {pass.map((digit, index) => (
                                    <div key={index} className="relative">
                                        {/* Container của mỗi ô: chuyển thành hình tròn, có hiệu ứng khung mờ */}
                                        <div className="w-14 h-14 md:w-20 md:h-20 flex items-center justify-center border-2 border-transparent rounded-full transition-all duration-300 focus-within:border-blue-500 ring-2 ring-gray-300 ring-opacity-50">
                                            <input
                                                type="text"
                                                inputMode="numeric"
                                                maxLength="1"
                                                value={digit}
                                                onChange={(e) => handleChange(e, index)}
                                                onKeyDown={(e) => handleKeyDown(e, index)}
                                                ref={(el) => (inputsRef.current[index] = el)}
                                                // Ẩn nội dung nhập (bao gồm cả caret) để chỉ hiển thị lớp phủ
                                                className="peer w-full h-full text-center text-3xl font-bold bg-transparent outline-none text-transparent caret-transparent"
                                            />
                                            {/* Lớp phủ: nếu đã nhập hiển thị chấm tròn, nếu chưa nhập hiển thị đường gạch ngang đậm */}
                                            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                                                {digit ? (
                                                    <span className="block w-4 h-4 bg-black rounded-full" />
                                                ) : (
                                                    <span className="block w-1/2 h-1 bg-gray-800" />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </> : (<>
                {!window.location.href.includes('memory') ? <Statistic /> : (<>
                    <div className="mt-2 text-center">
                        Chọn tệp media dưới
                    </div></>)}
                <Option /></>)}


        </>
    );
};

export default Admin_home;
